import { createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../api/apiSlice";

const CompalinWebAdaptor = createEntityAdapter({
    selectId: (entity) => entity.c_id,
})
const B2gCompalinWeb = CompalinWebAdaptor.getInitialState()

export const extendedApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getCompalinWeb: builder.query({
            query: () => '/b2g/eco-admin/complain',
            transformResponse: responseData => {
                if (responseData?.status === false) {
                    throw new Error(responseData?.statusCode)
                }
                return responseData?.data
            },
            providesTags: (result, error, arg) => {
                if (error || !result?.ids) {
                    return [{ type: 'B2gCompalinWeb', id: 'List' }, []];
                } else {
                    return result.ids.map(id => ({ type: 'B2gCompalinWeb', id }));
                }
            }
        }),
        getCompalinWebStatus: builder.query({
            query: () => '/b2g/eco-admin/complain/status',
            transformResponse: responseData => {
                if (responseData?.status === false) {
                    throw new Error(responseData?.statusCode)
                }
                return responseData?.data
            },
            providesTags: (result, error, arg) => {
                if (error || !result?.ids) {
                    return [{ type: 'B2gCompalinWeb', id: 'List' }, []];
                } else {
                    return result.ids.map(id => ({ type: 'B2gCompalinWeb', id }));
                }
            }
        }),
        editCompalinWeb: builder.mutation({
            query: (payLoad) => ({
                url: `/b2g/eco-admin/complain/${payLoad.id}`,
                method: 'PATCH',
                body: payLoad.body
            }),
            invalidatesTags: [
                { type: 'B2gCompalinWeb', id: 'List' }
            ]
        }),
        addCompalinWeb: builder.mutation({
            query: body => ({
                url: '/b2g/eco-admin/complain',
                method: 'POST',
                body: body
            }),
            invalidatesTags: [
                { type: 'B2gCompalinWeb', id: 'List' }
            ]
        }),
    })
})

export const {
    useGetCompalinWebQuery,
    useGetCompalinWebStatusQuery,
    useEditCompalinWebMutation,
    useAddCompalinWebMutation
} = extendedApiSlice